import { HttpStatusCode } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AuthTokenRES, BffUserRES } from '@smarsh-cyber/shared/api';
import { ErrorMessages } from '@smarsh-cyber/shared/constants';
import {
  ErrorModel,
  GlobalState,
  UserDetail
} from '@smarsh-cyber/shared/models';
import { Observable } from 'rxjs';
import * as AppActions from './app.actions';
import * as appFeature from './app.reducer';
@Injectable({
  providedIn: 'root'
})
export class AppFacadeService {
  tokenRefreshInterval = null;
  #store = inject(Store<GlobalState>);
  $isLoaded: Observable<boolean> = this.#store.select(
    appFeature.selectIsLoaded
  );
  $isError: Observable<boolean> = this.#store.select(appFeature.selectIsError);
  $error: Observable<ErrorModel> = this.#store.select(appFeature.selectError);

  $userToken = this.#store.selectSignal(appFeature.selectUserToken);

  userObservable$ = this.#store.select(appFeature.selectUser);

  $userDetails = this.#store.selectSignal(appFeature.selectUser);
  $impersonating = this.#store.select(appFeature.selectIsImpersonating);

  init(portalName: string, code: string, portalUrl: string) {
    this.#store.dispatch(AppActions.appInit({ portalName, code, portalUrl }));
  }

  refreshToken() {
    this.#store.dispatch(AppActions.refreshToken());
  }

  setPortalDetails(portalName: string, portalUrl: string) {
    this.#store.dispatch(
      AppActions.setPortalDetails({
        portalName,
        portalUrl
      })
    );
  }

  appLoadFailure(showError: boolean = false) {
    this.#store.dispatch(
      AppActions.appLoadFailure({
        error: {
          message: ErrorMessages.GENERIC_ERROR,
          status: HttpStatusCode.InternalServerError
        },
        showError
      })
    );
  }

  impersonate(
    impersonate: boolean,
    userToImpersonate: UserDetail | null,
    userWithoutPermission?: BffUserRES,
    navigateToDefault?: boolean
  ) {
    this.#store.dispatch(
      AppActions.impersonate({
        impersonate: impersonate,
        userToBeImpersonated: userToImpersonate,
        userWithoutPermission,
        navigateToDefault
      })
    );
  }

  initNgpLogin(portalName: string, portalUrl: string, token: AuthTokenRES) {
    this.#store.dispatch(
      AppActions.ngpInit({
        portalName,
        portalUrl,
        token
      })
    );
  }

  logout(redirectAfterLogout = true) {
    this.#store.dispatch(AppActions.ngpLogout({ redirectAfterLogout }));
  }
}
